import { createApi } from "@reduxjs/toolkit/query/react";
import {
  mapFreightInsuranceResponseToRows,
  mapRowsToFreightInsuranceRequest, // 👈 add request mapper
} from "@/redux//mappers/Export/CreateNewJob/InvoiceMapper/InvoiceFreightMapper";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";

export const invoicefreightApi = createApi({
  reducerPath: "invoicefreightApi",
  baseQuery,
  tagTypes: ["freightInsurance"],
  endpoints: (builder) => ({
    // 🔹 Get all invoices by masterId
    getInvoiceFreightByMasterId: builder.query({
      query: ({ id }) => `export/invoice/main/${id}`,
      transformResponse: (response) => {
        return response?.data[0] ?? [];
      },
      providesTags: ["freightInsurance"],
    }),

    // 🔹 Get single invoice by Id
    getInvoiceById: builder.query({
      query: ({ id, subId }) =>
        `export/invoice/freight-insurance/${id}/${subId}`,
      transformResponse: (response) => mapFreightInsuranceResponseToRows(response?.data) ?? [], 
      providesTags: (result, error, id) => [{ type: "freightInsurance", id }],
    }),

    // 🔹 Update freightInsurance by Id
    updateInvoiceFreight: builder.mutation({
      query: ({ id, dataId, ...data }) => ({
        url: `export/invoice/freight-insurance/${id}/${dataId}`,
        method: "PUT",
        body: { freightInsurance: mapRowsToFreightInsuranceRequest(data) },
        headers: {
          "X-Request-Id": crypto.randomUUID(),
        },
      }),
      invalidatesTags: ["freightInsurance"],
    }),
  }),
});

export const {
  useLazyGetInvoiceFreightByMasterIdQuery,
  useLazyGetInvoiceByIdQuery,
  useCreateInvoiceFreightMutation,
  useUpdateInvoiceFreightMutation,
  useDeleteInvoiceFreightMutation,
} = invoicefreightApi;
